import { Box, Typography } from "@mui/material";
import React from "react";
import { useLanguageLocale } from "../../hooks/language-locale-hooks";

export const HeaderInfo: React.FC<{ title: string ; entity: string; value?: string}> = (props) => {
    const { t } = useLanguageLocale();
    return (
        <>
            {<Box style={{ padding: 8}}>
                <Typography variant="h6" data-testid="header-info">
                    {props.title} {props.value}
                </Typography>
            </Box>
            }
            <Box style={{ padding: '8px' ,paddingBottom:16 }}>
                <Typography variant="body2" data-testid="asterisk-info">
                    {t('ADDLOCATION.ASTERIKSINFO', {
                        replace: { entity: props.entity }
                    })}
                </Typography>
            </Box>
           
        </>
    )
}